import {
  FavoritableModifiedIngredientsRdp,
  type Props as FavoritableRdpProps,
} from '../FavoritableModifiedIngredientsRdp/FavoritableModifiedIngredientsRdp';
import { Modal } from './Modal';

interface Props {
  onDismiss: () => void;
  pairing: FavoritableRdpProps['pairing'];
  modifiedIngredientIds: FavoritableRdpProps['modifiedIngredientIds'];
}

export function FavoritableModifiedIngredientsRdpModal(props: Props) {
  const { onDismiss, pairing, modifiedIngredientIds } = props;
  const { name: pairingName } = pairing;
  return (
    <Modal onDismiss={onDismiss} ariaLabel={pairingName}>
      <FavoritableModifiedIngredientsRdp
        modifiedIngredientIds={modifiedIngredientIds}
        pairing={pairing}
      />
    </Modal>
  );
}
